import React from 'react'
import { I18n } from '@front/volcanion'

import { TableCell } from '@mui/material'
import TextHeader from '@abra/elements/table/headers/Text'

const HistoryHeader = () => <>
  <TableCell size='small'>
    <TextHeader textAlign='center' label={I18n.t('voucher.label')} />
  </TableCell>
  <TableCell size='small'>
    <TextHeader textAlign='center' label={I18n.t('order.id.alter')} />
  </TableCell>
  <TableCell>
    <TextHeader textAlign='center' label={I18n.t('date.label', { count: 1 })} />
  </TableCell>
  <TableCell>
    <TextHeader textAlign='center' label={I18n.t('commercial_formula.label.short_alter')} />
  </TableCell>
  <TableCell>
    <TextHeader textAlign='center' label={I18n.t('user.label', { count: 1 })} />
  </TableCell>
</>

export default React.memo(HistoryHeader)
